import Constants from '@utils/constants';

export const rangeNumberValidate = (value: number | undefined, min?: number, max?: number): boolean => {
    return value !== undefined && (min === undefined || value >= min) && (max === undefined || value <= max);
};

export const isValidObjectId = (id: string) => id.length === 24 && /^[A-F0-9]+$/i.test(id);
export const isEmptyObjectId = (id: string) => id === Constants.ObjectId.Empty;

/**
 * Ensures that the given string only contains numbers, letters, spaces and underscores.
 * @param label The text to check.
 */
const cleanRegex = /^[\w _]+$/gm;

export const isValidTagLabel = (label: string) => label.match(cleanRegex);
export const isValidReviewTitle = (label: string) => label.match(cleanRegex);

/**
 * Ensures that the given string doesn't exceed 30 characters.
 * @param label The text to check.
 */
export const isValidTagLength = (label: string): boolean => {
    return label.length <= 30;
};
